//core-js doesnt have a nodelist.foreach polyfill yet, replace this once https://github.com/zloirock/core-js/pull/325 lands
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

import initClient from './initClient';

if (document.readyState !== "loading") {
    initClient();
} else {
    document.addEventListener("DOMContentLoaded", initClient);
}

import(/* webpackChunkName: "vdp" */ "../app/index.js");
